import React, { Fragment, useState, useEffect, useContext, useRef } from "react";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { appContext } from "../../../Utils/context";
import debounce from 'lodash.debounce';
import INH from '../../../assets/utils/images/avatars/INH.png';
import PRB from '../../../assets/utils/images/avatars/PRB.png';
import PRF from '../../../assets/utils/images/avatars/PRF.png';
import FSBO from '../../../assets/utils/images/avatars/FSBO.png';
import FRBO from '../../../assets/utils/images/avatars/FRBO.png';
import Select from "react-select";
import { Combobox } from "react-widgets";
import records from "../../../Services/records";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { toast, Slide } from "react-toastify";
// import * as XLSX from 'xlsx'
import {
  Label , Input,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Button,
  FormGroup, ListGroup, ListGroupItem, ModalFooter,
  Spinner,
  Modal, ModalBody
} from "reactstrap";
export default function Head({  newTags, setNewTags, uatId, data, list, setData, setList }) {

  // console.log("Data iss ", data)
  const { groupOptions, addressId, setAddressId } = useContext(appContext)
  const [propStatus, setPropStatus] = useState(null)
  const [searchData, setSearchData] = useState([])
  const [searchWord, setSearchWord] = useState(null)
  const [chooseWord, setChooseWord] = useState(null)
  const [busy, setBusy] = useState(false)
  const [show, setShow] = useState(false)
  const [state, setState] = useState('')
  const [county, setCounty] = useState('')
  const [city, setCity] = useState('')
  const [zip, setZip] = useState('')
  const [number, setNumber] = useState('')
  const [street, setStreet] = useState('')
  const [counties, setCounties] = useState([])
  const [cities, setCities] = useState([])
  const [zipes, setZipes] = useState([])
  const [showDropdown, setShowDropdown] = useState(false);
  const debouncedLookupRecordRef = useRef(null);


  useEffect(() => {
    if (chooseWord?.address_id !== null && chooseWord?.address_id !== undefined) {
      let isMounted = true;
      records.details({address_id:chooseWord?.address_id}).then((res) => {
        if (isMounted) {
          setData(res.data)
          setAddressId(res.data?.address_id)
        }
      }).catch((err) => { 
        console.log("error is", err)
      }).finally(() => {})
      return () => { isMounted = false };        
    }
}, [chooseWord?.address_id])




const lookupRecord = (val) => {
  setBusy(true)
  records.getLookupRecord({address:val}).then((res) => {
      setSearchData(res?.data)
  }).catch(err => console.log("error is", err)).finally(() => setBusy(false))

  if (val === "") {
      //console.log("Val", val)
      setSearchWord(null)
  }
}
if (!debouncedLookupRecordRef.current) {
  debouncedLookupRecordRef.current = debounce(lookupRecord, 500);
}
// const debouncedLookupRecord = debounce(lookupRecord, 2000);

const handleInputChange = (val) => {
  debouncedLookupRecordRef.current(val);
};

const save=()=>{
  if(state && county && city && zip && number && street){
    const info={
      situs_zip:zip,
      situs_county:county,
      situs_city:city,
      situs_state:state,
      situs_number:number,
      situs_street:street,
      ...data
    }
    setData(info)
    setShow(false)
  }else{
    notify22("Please select all Values", "error")
  }
}

const getdata = (val, key, toGet, add) => {
  const data = {
    [key]: val,
    to_get: toGet,
  };
  records.getSccz(data).then((res) => {
    if (toGet == "county" && add == "setCounties") {
      setCounties(res.data);
      setCounty('')
    } else if (toGet == "city" && add == "setCities") {
      setCities(res.data);
      setCity('')
    } else if (toGet == "zip" && add == "setZipes") {
      setZipes(res.data);
      setZip('')
    }
  });
};

const toggleShow = () => {
  setShow(!show)
}

  // const handleExport = () => {
  //   // console.log("export data", data)
  //   const school = data?.property_info?.schools
  //   var wb = XLSX.utils.book_new();
  //   var ws = XLSX.utils.json_to_sheet(list)
  //   XLSX.utils.book_append_sheet(wb, ws, "MySheet1")

  //   XLSX.writeFile(wb, "MyExcel.xlsx")
  // }

  const notify22 = (msg, type) =>
    toast(msg, {
      transition: Slide,
      autoClose: 5000,
      position: "top-right",
      type: type,

    });


  const groupStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: "#71879a",
    fontWeight: "bold",
    fontSize: 14,
  };
  const groupBadgeStyles = {
    backgroundColor: "#EBECF0",
    borderRadius: "2em",
    color: "#172B4D",
    display: "inline-block",
    fontSize: 12,
    fontWeight: "normal",
    lineHeight: "1",
    minWidth: 1,
    padding: "0.16666666666667em 0.5em",
    textAlign: "center",
  };

  const formatGroupLabel = (data) => (
    <div style={groupStyles}>
      <span className="" >{data.label}</span>
      <span style={groupBadgeStyles}>{data.options.length}</span>
    </div>
  );


  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      paddingLeft: "40px",
    }),
  }

  const onStatusChange = (status) => {
    if(uatId !== undefined && uatId !== null){
    const info ={
      property_status : {pipeline:status?.group,tag_name:status?.value}
  }
  records
      .addNewTags(uatId.toString(),info)

    // records.AddTags({ uat_id: data?.uat_id?.toString(), status_type: "property_status", status_value: `{"status": "${status?.value}","value": "${status?.value}","label": "${status?.value}","group": "${status?.group}"}` })
    .then((res) => {
       setNewTags(res.data)
       const updatedList = list?.map((object) => {
        if (object.uat_id === uatId) {
          return { ...object, property_status: res?.data?.property_status };
        }
        return object;
      });
      setList(updatedList)

      notify22("Property Status Updated", "success")
    }).catch((err) => {
      console.log("erroriz ", err)
    })
  }
  else{
    setNewTags({...newTags,property_status:JSON.stringify(status) })
      notify22("Property Status Updated", "success")
  }
  }

  const handleMenuOpen = () => {
    setTimeout(() => {
      const selectedEl = document.getElementsByClassName("MyDropdown__option--is-selected")[0];
      if (selectedEl) {
        selectedEl.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    }, 700);
  }
  const findMatchingOption = (data, pipeline, tag) => {
    for (const obj of data) {
        for (const option of obj.options) {
          if (option.group === pipeline && option.label === tag) {
            return option;
          }
        }
    }
    return null; // If no match is found
  };

  const clear =()=>{
    if(addressId){
      setAddressId('')
      setData({
        people:[{
          title:'',
          age:'',
          first_name:'',
          last_name:'',
          middle_name:'',
          suffix:'',
          addresses:[{
            zip:'',
            city:'',
            state:'',
            address1:'',
        }]
      }]
    })
    }else{
      setState('')
      setCounty('')
      setCity('')
      setZip('')
      setNumber('')
      setStreet('')
      setCounties([])
      setCities([])
      setZipes([])
      setData({people:data?.people});
    }
  }

  return (
    <Fragment>
      <TransitionGroup>
        <CSSTransition component="div" classNames="TabsAnimation" appear={true}
          timeout={0} enter={false} exit={false}>
          <Row>
            <Col md="12">
              <Card className="main-card pb-0 ">
                <CardBody>

                  <Row className="g-0">
                    <Col md="5">
                      {Object.keys(data).filter(key => key !== 'people').length === 0 ? (
                        // <Combobox
                        //   busy={busy}
                        //   hideCaret
                        //   hideEmptyPopup
                        //   value={searchWord}
                        //   className="mt-2"
                        //   filter='contains'
                        //   dataKey="address_id" 
                        //   textField="situs_official_street_address"
                        //   data={searchData}
                        //   placeholder="Property Address"
                        //   onChange={(val) => { handleInputChange(val); setSearchWord(val) }}
                        // />
                        <>
                        <Input
        type="text"
        value={searchWord}
        onChange={(e) => {handleInputChange(e.target.value);setSearchWord(e.target.value)}}
        placeholder="Search..."
        onFocus={() => setShowDropdown(true)} // Show dropdown on focus
        onBlur={() => {
          // Set a timeout to close the dropdown after 1 second
          setTimeout(() => {
            setShowDropdown(false);
          }, 500);
        }}// Hide dropdown on blur
      />
      {(showDropdown && searchData.length> 0) && (
        <div
        style={{ 
          display:'block',
          maxHeight: '150px', // Set max height
          width: 'inherit', // Match width with input
          overflowY: 'auto', // Enable vertical scrolling
          border: '1px solid #ccc', // Optional: Add border for styling
        }} className="dropdown-menu">
          {searchData.map((item) => (
            <div
              key={item.address_id}
              className="dropdown-item"
              onClick={() =>{setChooseWord(item);setSearchData('');setSearchWord(item?.situs_official_street_address)}}
            >
              {item.situs_official_street_address}
            </div>
          ))}
        </div>
      )}
                        </>
                      ) : (
                        <>
                          <h4>
                            {data.situs_number} {data.situs_street}, {data.situs_city}, {data.situs_state} {data.situs_zip}
                          </h4>
                          <div className="mt-1 fw-light text-capitalize">
                            Beds: {data.beds || "-"} | Baths: {data.baths || "-"} | Built: {data.year_built || "-"} | Living: {data.building_area || "-"} Sqft | Lot: {data.land_area || "-"} Sqft
                          </div>
                        </>
                      )}

                    </Col>
                    <Col md="5" className="mt-1" >
                    {Object.keys(data).filter(key => key !== 'people').length  === 0 ? (<>
                    <Button
                          onClick={()=> setShow(true)}
                          outline
                          className=" btn-wide btn-transition mt-1 ms-2"
                          color="primary">Add Manually</Button>
                    </>):(
                      <>
                      {!uatId && (<>
                      <Button outline onClick={clear}
                          className=" btn-wide btn-transition mt-1 ms-2"
                          color="secondary"
                          >Clear</Button>
                          {!addressId && <Button outline onClick={()=> setShow(true)}
                          className=" btn-wide btn-transition mt-1 ms-2"
                          color="primary"
                          >Edit</Button>}
                          </>)}

                          {uatId && (<> <div className="avatar-icon-wrapper avatar-icon-md">
                          <div className="avatar-icon rounded">
                            {data?.leads_images_urls && data?.leads_images_urls?.map((img,index)=>(
                              <img key={index}
                              style={{ width: "40px" }}
                              src={ (() => {
                                      try {
                                        return require(`../../../assets/utils/images/avatars/${img
                                          .split(".")[0]
                                          .toUpperCase()}.${img
                                          .split(".")[1]
                                          .toLowerCase()}`);
                                      } catch (error) {
                                        // console.error(`Error loading image: ${error.message}`);
                                        return "";
                                      }
                                    })()
                              }
                              alt=""
                            />
                            ))}
                          </div>
                        </div></>)}
                        

                      {/* {data?.lead_info?.inheritance &&
                        <div className="avatar-icon-wrapper avatar-icon-md">
                          <div className="avatar-icon rounded">
                            <img src={INH} alt="" />
                          </div>
                        </div>
                      }
                      {data?.lead_info?.preforeclosure &&
                        <div className="avatar-icon-wrapper avatar-icon-md">
                          <div className="avatar-icon rounded">
                            <img src={PRF} alt="" />
                          </div>
                        </div>
                      }
                      {data?.lead_info?.fsbo &&
                        <div className="avatar-icon-wrapper avatar-icon-md">
                          <div className="avatar-icon rounded">
                            <img src={FSBO} alt="" />
                          </div>
                        </div>
                      }
                      {data?.lead_info?.frbo &&
                        <div className="avatar-icon-wrapper avatar-icon-md">
                          <div className="avatar-icon rounded">
                            <img src={FRBO} alt="" />
                          </div>
                        </div>
                      } */}
                      </>
                      )}
                    </Col>
                    <Col md="2" className="mt-2">

                    {/* <Select placeholder="Select Status" value={newTags?.property_status && JSON.parse(newTags?.property_status)} styles={customStyles} options={groupOptions} formatGroupLabel={formatGroupLabel} onChange={onStatusChange} onMenuOpen={handleMenuOpen} className={"MyDropdown"} classNamePrefix={"MyDropdown"} /> */}
                    <Select placeholder="Select Status" value={findMatchingOption(groupOptions,newTags?.property_status?.pipeline,newTags?.property_status?.tag_name)} styles={customStyles} options={groupOptions} formatGroupLabel={formatGroupLabel} onChange={onStatusChange} onMenuOpen={handleMenuOpen} className={"MyDropdown"} classNamePrefix={"MyDropdown"} />
                      {/* <Select placeholder="Select Status" value={findMatchingOption(groupOptions,'hejed','hello')} options={groupOptions}  onChange={onStatusChange}/> */}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Modal isOpen={show} toggle={toggleShow} style={{ minWidth: "45%" }}>
                            <Card className="mb-2">
                                <CardHeader className="card-header-tab">
                                    <div className="card-header-title font-size-lg text-capitalize fw-normal">
                                        <i className="header-icon lnr-file-add icon-gradient bg-happy-green"> {" "} </i>
                                        <span className="menu-header-title text-capitalize">Add Manually</span>
                                    </div>
                                    <Button  onClick={toggleShow}
                    className=" me-3 border-0 btn-transition position-absolute end-0"
                    outline
                    color="secondary"
                    title=" Cancel"
                    // onClick={() => toggleShow()}
                  ><FontAwesomeIcon icon={faTimes} size="2x" /></Button>
                                </CardHeader>
                            </Card>
                            <ModalBody>
                                
                              <Row>
                              <Col sm={12}>
                              <FormGroup floating>
                                <Input
                                value={state}
                                  type="select"
                                  onChange={(e) => {
                                    getdata(
                                      e.target.value,
                                      "state",
                                      "county",
                                      "setCounties"
                                    );
                                    setState(e.target.value);
                                  }}
                                >
                                  <option value="">Select State</option>
                                  <option value="ak">Alaska</option>
                                  <option value="al">Alabama</option>
                                  <option value="ar">Arkansas</option>
                                  <option value="as">American Samoa</option>
                                  <option value="az">Arizona</option>
                                  <option value="ca">California</option>
                                  <option value="co">Colorado</option>
                                  <option value="ct">Connecticut</option>
                                  <option value="dc">
                                    District of Columbia
                                  </option>
                                  <option value="de">Delaware</option>
                                  <option value="fl">Florida</option>
                                  <option value="fm">
                                    Federated States of Micronesia
                                  </option>
                                  <option value="ga">Georgia</option>
                                  <option value="gu">Guam</option>
                                  <option value="hi">Hawaii</option>
                                  <option value="ia">Iowa</option>
                                  <option value="id">Idaho</option>
                                  <option value="il">Illinois</option>
                                  <option value="in">Indiana</option>
                                  <option value="ks">Kansas</option>
                                  <option value="ky">Kentucky</option>
                                  <option value="la">Louisiana</option>
                                  <option value="ma">Massachusetts</option>
                                  <option value="md">Maryland</option>
                                  <option value="me">Maine</option>
                                  <option value="mh">Marshall Islands</option>
                                  <option value="mi">Michigan</option>
                                  <option value="mn">Minnesota</option>
                                  <option value="mo">Missouri</option>
                                  <option value="mp">
                                    Northern Mariana Islands
                                  </option>
                                  <option value="ms">Mississippi</option>
                                  <option value="mt">Montana</option>
                                  <option value="nc">North Carolina</option>
                                  <option value="nd">North Dakota</option>
                                  <option value="ne">Nebraska</option>
                                  <option value="nh">New Hampshire</option>
                                  <option value="nj">New Jersey</option>
                                  <option value="nm">New Mexico</option>
                                  <option value="nv">Nevada</option>
                                  <option value="ny">New York</option>
                                  <option value="oh">Ohio</option>
                                  <option value="ok">Oklahoma</option>
                                  <option value="or">Oregon</option>
                                  <option value="pa">Pennsylvania</option>
                                  <option value="pr">Puerto Rico</option>
                                  <option value="ri">Rhode Island</option>
                                  <option value="pw">Palau</option>
                                  <option value="sc">South Carolina</option>
                                  <option value="sd">South Dakota</option>
                                  <option value="tx">Texas</option>
                                  <option value="tn">Tennessee</option>
                                  <option value="ut">Utah</option>
                                  <option value="va">Virginia</option>
                                  <option value="vi">Virgin Islands</option>
                                  <option value="vt">Vermont</option>
                                  <option value="wa">Washington</option>
                                  <option value="wi">Wisconsin</option>
                                  <option value="wv">West Virginia</option>
                                  <option value="wy">Wyoming</option>
                                  <option value="aa">
                                    Armed Forces Americas
                                  </option>
                                  <option value="ae">
                                    Armed Forces Africa
                                  </option>
                                  <option value="ap">
                                    Armed Forces Pacific
                                  </option>
                                </Input>

                                <Label for="examplePassword">State</Label>
                              </FormGroup>
                            </Col>
                            <Col sm={12}>
                              <FormGroup floating>
                                <select
                                  className="form-select"
                                  type="select"
                                  value={county}
                                  onChange={(e) => {
                                    getdata(
                                      e.target.value,
                                      "county",
                                      "city",
                                      "setCities"
                                    );
                                    setCounty(e.target.value);
                                  }}
                                >
                                  <option value="">Select County</option>
                                  {counties &&
                                    counties.map((county, k) => (
                                      <option key={k} value={county}>
                                        {county}
                                      </option>
                                    ))}
                                </select>

                                <Label for="examplePassword">County</Label>
                              </FormGroup>
                            </Col>
                            <Col sm={12}>
                              <FormGroup floating>
                                <select
                                value={city}
                                  className="form-select"
                                  type="select"
                                  onChange={(e) => {
                                    getdata(
                                      e.target.value,
                                      "city",
                                      "zip",
                                      "setZipes"
                                    );
                                    setCity(e.target.value);
                                  }}
                                >
                                  <option value="">Select City</option>
                                  {cities &&
                                    cities.map((city, k) => (
                                      <option key={k} value={city}>
                                        {city}
                                      </option>
                                    ))}
                                </select>

                                <Label for="examplePassword">City</Label>
                              </FormGroup>
                            </Col>
                            <Col sm={12}>
                              <FormGroup floating>
                                <select
                                value={zip}
                                  className="form-select"
                                  type="select"
                                  onChange={(e) => {
                                    setZip(e.target.value);
                                  }}
                                >
                                  <option value="">Select Zip</option>
                                  {zipes &&
                                    zipes.map((zip, k) => (
                                      <option key={k} value={zip}>
                                        {zip}
                                      </option>
                                    ))}
                                </select>

                                <Label for="examplePassword">Zip</Label>
                              </FormGroup>
                            </Col>
                            <Col sm={12}>
                              <FormGroup floating>
                                <Input
                                value={street}
                                  type="text"
                                  onChange={(e) => {
                                    setStreet(e.target.value);
                                  }}
                                />
                                <Label for="examplePassword">Street</Label>
                              </FormGroup>
                            </Col>
                            <Col sm={12}>
                              <FormGroup floating>
                                <Input
                                  type="text"
                                  value={number}
                                  onChange={(e) => {
                                    setNumber(e.target.value);
                                  }}
                                />
                                <Label for="examplePassword">Number</Label>
                              </FormGroup>
                            </Col>
                            {/* <Multiselect
                              data={zipes}
                              value={zip}
                              placeholder="Select Zipcode"
                              onChange={(value) => {
                                setZip(value);
                              }}
                              textField="name"
                            /> */}
                              </Row>
                            </ModalBody>
                            <ModalFooter>
                                        <Row >
                                            <Col xs="6" >
                                                <Button onClick={save} block outline className=" btn-wide btn-transition" color="primary">
                                                    Save
                                                </Button>
                                            </Col>
                                            <Col xs="6">
                                                <Button block outline className=" btn-wide  btn-transition" color="secondary" onClick={toggleShow}>
                                                    Cancel
                                                </Button>
                                            </Col>
                                        </Row>
                                    </ModalFooter>
                        </Modal>
          </Row>
        </CSSTransition>
      </TransitionGroup>
    </Fragment>
  )
}